__turbopack_context__.v({
  "arrow": "LinkWithArrow-module-sass-module__n1ZZcq__arrow",
  "content": "LinkWithArrow-module-sass-module__n1ZZcq__content",
  "link_with_arrow": "LinkWithArrow-module-sass-module__n1ZZcq__link_with_arrow",
});
